<template>
  <youtube :child-id="id" />
</template>

<script>
  import Youtube from '@/components/Child/ChildTabs/TabYouTube/YouTube.vue'

  export default {
    props: {
      id: {
        required: true
      }
    },

    components: {
      Youtube
    }
  }
</script>